<template>
  <div class="anchor-item-component">
    <img class="anchor-item-img" :src="anchor.avatar" />
    <div class="item-title flex-middle-only">
      {{anchor.nick_name}}
      <img v-if="anchor.living === 1" style="margin-left: .04rem;height: .18rem;" src="../match-recommend/24.gif" alt="">
    </div>
    <div class="item-focus"><span class="num">{{anchor.fans_num}}</span>人关注</div>
  </div>
</template>

<script>
  export default {
    props:{
      anchor:{
        type : Object,
        default(){
          return {}
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .anchor-item-component{
    width : 100%;
    height: 178px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.1);
    border-radius: 8px;
    display : flex;
    justify-content : center;
    align-items : center;
    flex-direction : column;
    cursor : pointer;
    .anchor-item-img{
      width : 80px;
      height : 80px;
      border-radius: 50%;
      overflow : hidden;
    }
    .item-title{
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 400;
      margin : 10px 0px;
    }
    .item-focus{
      font-size : 14px;
      color: #666666;
      letter-spacing: 0;
      font-weight: 400;
    }
    .num{
       color : #26D99D;
    }
  }
</style>
